import {
  createReducer,
} from 'helpers/ReducerUtil'
import {
  UPDATE_VALUE
} from './constants'

const updateValue = (values, action) => {
  const val = action.value == null ? null : action.value.value
  return [ { value : val } ]
}

const dropdownReducer = createReducer([], {
  [UPDATE_VALUE]: updateValue
})

export default dropdownReducer
